export default "__VITE_ASSET__BLSRVn$$__"